
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotorOnHorisontal as ObiMotorOnHorisontalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-motor-on-horisontal.js';
 
 
 

 
 export const ObiMotorOnHorisontal = createComponent({
   react: React,
   tagName: 'obi-motor-on-horisontal',
   elementClass: ObiMotorOnHorisontalElement,
   events: {
     
   }
  });
 
 